import { NavController, NavParams, LoadingController, Events} from 'ionic-angular';
import { ActionSheetController, AlertController, Content } from 'ionic-angular';
import { Component,ViewChild, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ProfileService } from '../../../../../UI/src/app/shared/profile/profile.service';
import { GeoLocationService } from '../../../../../UI/src/app/shared/location/geo-location.service';
import { ResumeService } from '../../../../../UI/src/app/shared/resume/resume.service';
import { CandidateProfileComponent } from '../candidate-profile/candidate-profile.component';
import { EditProfileComponent } from '../edit-profile/edit-profile.component';
import { Storage } from '../../../../../UI/src/app/shared/constants';
import { ToastControllerService } from '../../../providers/toast-controller.service';
import { JobAlertService } from '../../../../../UI/src/app/shared/job-alert/job-alert.service';
import { Toast508Service } from '../../../providers/toast-508.service';
import { JobApplyObject } from '../../../../../UI/src/app/shared/job/job-apply-object.dto';
import { JobService } from '../../../../../UI/src//app/shared/job/job.service';
import { JobAssessmentComponent } from '../job-search/components/job-assessment/job-assessment.component';
import { JobDetailsDTO } from '../../../../../UI/src/app/shared/job/job-details.dto';
import { AuthenticationService } from '../../../../../UI/src/app/shared/authentication/authentication.service';

@Component({
  selector: 'review-candidate-profile',
  templateUrl: 'review-candidate-profile.component.html'
})
export class ReviewCandidateProfileComponent {
  @ViewChild(Content) content: Content;  
  jobApplied: boolean = false;
  timelineDataOriginal: any;
  previousFilter = null;
  tabSelected = 'RESUMEPROFILE';  
  candidateTranslations: any;
  resumeType: number = 0;
  timelineMap = null
  timelineData: any = [];
  resumeTypeClass: any;
  profileData: any = {};
  data: any;
  resumeId: number;
  resumeData: any;
  resumeSaveResponse: any;
  resumeAction: any;
  alertData: any;
  job: any;
  jobDetails: JobDetailsDTO = null;
  navigatedFrom = '';
  showNavbar = false;
  private alive = true;
  isSelfAssessment =false;
  @Input() isApplyWithLinkedIn = false;

  constructor(
    public navCtrl: NavController,
    public events: Events,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    private profileService: ProfileService,
    private jobAlertService: JobAlertService,
    private geoLocationService: GeoLocationService,
    private toastService: ToastControllerService,
    private toast508Service: Toast508Service,
    private resumeService : ResumeService,
    public actionSheetCtrl: ActionSheetController,
    public alertCtrl: AlertController,
    private translate: TranslateService,
    private jobService: JobService,
    private authenticationService: AuthenticationService
  ) {
    this.translate.get(['CAREER_FAILED_MESSAGE',
      'CAREER_JOB_ALERT_CREATED',
      'CAREER_ALERT_UPDATE_MESSAGE',
      'CAREER_ALERT_DELETE_MESSAGE',
      'CAREER_JOBALERT_DELETE_CONFIRMATION',
      'CAREER_CANCEL', 'CAREER_OK',
      'CAREER_EDIT_LABEL',
      'CAREER_DELETE',
      'CAREER_APPLIED_SUCCESS',
      'CAREER_ALREADY_APPLIED'
    ]).subscribe((obj) => {
      this.candidateTranslations = obj;
    });
    this.events.publish('showSiteMapNodes', true);
    this.resumeAction = this.resumeService.getResumeAction();
    this.showNavbar = this.resumeAction.showNavbar;
    if (navParams.data) {
      this.navigatedFrom = navParams.get("navigatedFrom");
      this.resumeData = navParams.get("resumeData");      
    }
    this.timelineMap = this.resumeService.getTimelineMap(); 
     
  }

  ionViewDidLoad() {
  }

  ngOnInit() {
    this.getDataAndConfig();
    this.getProfileData();
    if(!this.resumeData) {
      if (this.authenticationService.isAppliedwithLinkedIn && !this.authenticationService.isResumeRequired &&
        !this.resumeService.getFromEditResume()) {
         this.resumeData = this.resumeService.getResume();
          if (this.resumeData.id > 0) {
            this.resumeService.getResumeDataByID(this.resumeData.id)
            .takeWhile(() => this.alive)
            .subscribe(data => {
                this.resumeData = data;
            });
            }
     }
      else {
        this.getResumeId();
        this.getResumeData();
      }
    }
  }

  private getDataAndConfig() {
    this.data = this.resumeService.getResumeConfig('TIMELINE');
    this.timelineData = [];
    if (this.data) {
      for (var i = 0; i < this.data.sections.length; i++) {
        const tlObj = this.data.sections[i];
        var tempArr = this.resumeService.getResumeValue(this.timelineMap[tlObj.name].dto);
        //if no resume then no data to be displayed.
        if (tempArr == undefined) {
          this.timelineDataOriginal = [];
          return;
        }
        for (var j = 0; j < tempArr.length; j++) {
          this.timelineData.push({
            data: tempArr[j],
            config: tlObj,
            icon: this.timelineMap[tlObj.name].icon
          });
        }
      }
    }
  }    

  getProfileData() {
    this.profileService.getProfileData().subscribe(
      (response) => {
        this.profileData = response[0];
        if (!this.profileData.fullName || this.profileData.fullName === '- -') {
          this.profileData.fullName = 'Add Name';
        }
        if (!this.profileData.jobTitle) {
          this.profileData.jobTitle = 'Add Job Title';
        }
        if (!this.profileData.phone) {
          this.profileData.phone = 'Add Phone Number';
        }
        if (!this.profileData.email1) {
          this.profileData.phone = 'Add Email';
        }
        this.profileData.address = this.concatStrings([this.profileData.city, this.profileData.state], ', ');
        if (!this.profileData.address) {
          this.profileData.address = 'Add Location';
        }
        this.resumeType = this.profileData.resumeType;
        switch (this.resumeType) {
          case 1:
            this.resumeTypeClass = 'fa-info';
            break;
          case 2:
            this.resumeTypeClass = 'fa-linkedin-square';
            break;
          case 3:
            this.resumeTypeClass = 'fa-file-text';
            break;
        }
        if (this.profileData.imagePath && !this.profileData.imagePath.match(/^(https?:\/\/)/gi)) {
          this.profileData.imagePath = window.localStorage.getItem(Storage.DATASTORE) + 'PersonImages/' + this.profileData.imagePath;
        }        
      }, (error) => {
        // TODO : Implement alert
      }
    );
  }
  
  concatStrings(inputString, concatChar) {
    let outputString = [];
    inputString.forEach(element => {
      if (element) {
        outputString = outputString.concat(element.trim());
      }
    });
    return outputString.join(concatChar);
  }

  selectTab(selectedTab) {
    this.tabSelected = selectedTab; 
  }
  
  cancelStep() {    
    this.isApplyWithLinkedIn = false;
    this.resumeService.setAddResumeFromScratch(false);
    this.resumeService.setReviewAndConfirm(false);
    this.authenticationService.isAppliedwithLinkedIn = false;
    this.navCtrl.setRoot(CandidateProfileComponent);
  }
  
  editStep() {
    this.resumeService.setResumeAction({action: 'EDIT_RESUME', isInititalCreation: this.resumeAction.isInititalCreation, isJobApply: this.isApplyWithLinkedIn ? this.isApplyWithLinkedIn : this.resumeAction.isJobApply});
    this.navCtrl.push(EditProfileComponent);
  } 

  confirmStep() {
    this.resumeData.isConfirmed = true;
    this.resumeService.saveResumeData(this.resumeData).subscribe(
      (response) => {
        this.resumeSaveResponse = response;
        if (this.resumeAction.isJobApply) {
          this.applyForJob();
        } else {
          this.navCtrl.setRoot(CandidateProfileComponent);
        }        
      }, (error) => {
        // TODO : Implement alert
      }
    );    
  } 

  private getResumeId() {
    this.resumeId = this.resumeService.getResumeId();
  }

  private getResumeData() {
    this.resumeService.getResumeData().subscribe(
      (response) => {
        this.resumeData = response;
      }, (error) => {
        // TODO : Implement alert
      });
    }

  private applyForJob() {
    const jobApplyObject: JobApplyObject = this.jobService.getApplyJobObject();
    this.isSelfAssessment =false;
    this.jobService.getSelfAssessmentForRequisition(jobApplyObject.JobId).subscribe(
      (selfAssresponse) => {
        if( selfAssresponse.selfAssessments.length > 0)
        {
          this.isSelfAssessment =true;
        }
        else
        {
          this.isSelfAssessment = false;
        }
      });

    if (jobApplyObject != null && jobApplyObject.JobId != null) {
      this.jobService.getAssessmentIdForRequisition(jobApplyObject.JobId)
      .subscribe((response) => {
        if(response === 0 || response == null) {
          let resumeId = -1;
          if(this.authenticationService.isAppliedwithLinkedIn) {
              resumeId = this.resumeService.getResumeId();
            }
            if(this.isSelfAssessment === false && (response === 0 || response == null))
            {
              this.profileService.applyJob(jobApplyObject.JobId,'',resumeId).subscribe(
                  (response) => {
                    if (response > 0) {
                      // Job Applied
                      this.jobService.setSuccessAlert(0);
                    } else if (response === -1) {
                      // Job Already Applied
                      this.jobService.setSuccessAlert(1);
                    } else if (response === -50) {
                      // Job Applied Failure
                      this.jobService.setSuccessAlert(2);
                    }
                    this.showAlert();
                    if(response > 0 && this.authenticationService.isAppliedwithLinkedIn) {
                      this.authenticationService.isAppliedwithLinkedIn =false;
                      this.navCtrl.setRoot(CandidateProfileComponent, {'trackRequest' : jobApplyObject.JobId});
                    } else {
                      this.navCtrl.setRoot(CandidateProfileComponent);
                    }
                    
                  }, (error) => {
    
               });                     
            }  
            else
            {         
             this.navCtrl.push(JobAssessmentComponent, {"assessmentId": response, "jobId": jobApplyObject.JobId, "navigatedFrom": this.navigatedFrom, "isAssessment": false,"isSelfAssessment": true});
            }
        }
        else {
          this.navCtrl.push(JobAssessmentComponent, {"assessmentId": response, "jobId": jobApplyObject.JobId, "navigatedFrom": this.navigatedFrom, "isAssessment": false});
        }
      }, (error) => {
        this.alertData = { message: this.candidateTranslations.CAREER_FAILED_MESSAGE, type: 'error' };
        this.toastService.presentToast(this.alertData);
        this.toast508Service.toFocus();
      });
    }
  }

  showAlert() {
    const jobApplyStatus = this.jobService.getSuccessAlert();
    if (jobApplyStatus === 0) {
      this.alertData = {
        message: this.candidateTranslations.CAREER_APPLIED_SUCCESS,
        type: 'success'
      };
      this.jobService.setSuccessAlert(3);
    } else if (jobApplyStatus === 1) {
      this.alertData = { message: this.candidateTranslations.CAREER_ALREADY_APPLIED, type: 'info' };
      this.jobService.setSuccessAlert(3);
    } else if (jobApplyStatus === 2) {
      this.alertData = { message: this.candidateTranslations.CAREER_FAILED_MESSAGE, type: 'error' };
      this.jobService.setSuccessAlert(3);
    } else {
      this.alertData = null;
    }
    if (this.alertData != null) {
      this.toastService.presentToast(this.alertData);
      this.toast508Service.toFocus();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/review-candidate-profile/review-candidate-profile.component.ts